import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import './App.css';
import Provider from './context/Provider';
import Login from './pages/Login';
import Home from './pages/Home';
import Header from './components/Header';
import Burger from './components/Burguer';
import Config from './pages/Config';
import CallCenter from './pages/Callcenter'
import CallcenterV2 from './pages/CallcenterV2'
import CallcenterV2Layout from './pages/CallcenterV2/Layout'
import CallcenterV2Queues from './pages/CallcenterV2/QueuesConfig'
import CallcenterV2Skills from './pages/CallcenterV2/SkillsConfig'
import CallcenterV2Agents from './pages/CallcenterV2/AgentsConfig'
import CallcenterV2Reports from './pages/CallcenterV2/Reports'
import CallcenterV2History from './pages/CallcenterV2/History'
import CallcenterV2Dashboard from './pages/CallcenterV2/Dashboard'
import CallcenterV2MetricsCatalog from './pages/CallcenterV2/MetricsCatalog'
// Phase 5 imports (behind ccv2_phase5_ui feature flag)
import CallcenterV2DashboardRouter from './pages/CallcenterV2/DashboardRouter'
import CallcenterV2DashboardManager from './pages/CallcenterV2/DashboardManager'
import CallcenterV2DashboardAgent from './pages/CallcenterV2/DashboardAgent'
import CallcenterV2PauseReasons from './pages/CallcenterV2/PauseReasons'
import CallcenterV2WorkSchedules from './pages/CallcenterV2/WorkSchedules'
import CallcenterV2MetricsCatalogAdmin from './pages/CallcenterV2/MetricsCatalogAdmin'
import CallcenterV2FeatureFlags from './pages/CallcenterV2/FeatureFlags'
import CallcenterV2Realtime from './pages/CallcenterV2/Realtime'
import CallcenterV2AuditLog from './pages/CallcenterV2/AuditLog'
import CreateEndpoints from './components/Config/Endpoints/EndpointsCreate';
import ListEndpoints from './components/Config/Endpoints/EndpointsList';
import ListEndpointsById from './components/Config/Endpoints/EndpointsListById';
import CreateTrunks from './components/Config/Trunks/TrunksCreate';
import EditTrunks from './components/Config/Trunks/TrunksEdit';
import ListTrunks from './components/Config/Trunks/TrunksList';
import ListTrunksById from './components/Config/Trunks/TrunksListById';
import TrunksInboundDispatcherManage from './components/Config/Trunks/TrunksInboundDispatcherManage';
import ChangeIp from './components/Config/System/ChangeIp';
import InterfacesList from './components/Config/System/InterfacesList';
import PjsipTransports from './components/Config/Asterisk/PjsipTransports';
import PjsipTuning from './components/Config/Asterisk/PjsipTuning';
import QueuesCreate from './components/Config/Queues/QueuesCreate';
import QueuesList from './components/Config/Queues/QueuesList';
import QueuesListById from './components/Config/Queues/QueuesListById';
import MembersQueuesCreate from './components/Config/Queues/MembersQueuesCreate';
import QueuesMembersList from './components/Config/Queues/QueuesMembersList';
import RoutesNewSet from './components/Config/System/RoutesNew';
import RoutesList from './components/Config/System/RoutesList';
import MemberQueuesById from './components/Config/Queues/components/MembersListById';
import DialPlanEntrance from './components/Config/DialPlan/DialPlanEntranceCalls';
import DialPlanInternal from './components/Config/DialPlan/DialPlanInternalCalls';
import DialPlanExternal from './components/Config/DialPlan/DialPlanExternalCalls';
import CreateUsers from './components/Config/Users/UsersCreate';
import ListUsers from './components/Config/Users/UsersList';
import UsersEdit from './components/Config/Users/UsersEdit';
import UsersView from './components/Config/Users/UsersView';
import ListContacts from './components/Contacts/ContactsList';
import NewContact from './components/Contacts/ContactsCreate';
import ContactById from './components/Contacts/ContactsListById';
import ContactShowById from './components/Contacts/ContactsShowById';
import LogsVigoscloud from './components/Events/LogsVigoscloud';
import PingPage from './components/Config/System/PingIp';
import Dashboard from './pages/Dashboard/index';
import Uploads from './components/Config/Uploads/UraAndMohUpdate';
import UploadsList from './components/Config/Uploads/UraAndMohList';
import Tenants from './components/Config/Tenant/TenantCreate';
import TenantsList from './components/Config/Tenant/TenantsList';
import MohCreate from './components/Config/Moh/MohCreate';
import MohEdit from './components/Config/Moh/MohEdit';
import MohList from './components/Config/Moh/MohList';
import MohView from './components/Config/Moh/MohView';
import IntegrationsList from './components/Config/Integrations/IntegrationsList';
import IntegrationsCreate from './components/Config/Integrations/IntegrationsCreate';
import IntegrationsEdit from './components/Config/Integrations/IntegrationsEdit';
import IntegrationsView from './components/Config/Integrations/IntegrationsView';
import InternalCallsList from './components/Config/InternalCalls/InternalCallsList';
import InternalCallsCreate from './components/Config/InternalCalls/InternalCallsCreate';
import InternalCallsEdit from './components/Config/InternalCalls/InternalCallsEdit';
import InternalCallsView from './components/Config/InternalCalls/InternalCallsView';
import InternalCallsStatistics from './components/Config/InternalCalls/InternalCallsStatistics';
import OutboundCallsList from './components/Config/OutboundCalls/OutboundCallsList';
import OutboundCallsCreate from './components/Config/OutboundCalls/OutboundCallsCreate';
import OutboundCallsEdit from './components/Config/OutboundCalls/OutboundCallsEdit';
import OutboundCallsView from './components/Config/OutboundCalls/OutboundCallsView';

// Incoming Calls Components
import IncomingCallsList from './components/Config/IncomingCalls/IncomingCallsList';
import IncomingCallsCreate from './components/Config/IncomingCalls/IncomingCallsCreate';
import IncomingCallsEdit from './components/Config/IncomingCalls/IncomingCallsEdit';
import IncomingCallsView from './components/Config/IncomingCalls/IncomingCallsView';

// URA Components
import URAList from './components/Config/URA/URAList';
import URACreate from './components/Config/URA/URACreate';
import URAEdit from './components/Config/URA/URAEdit';
import IncomingCallsStatistics from './components/Config/IncomingCalls/IncomingCallsStatistics';

// Message Components
import MessageList from './components/Config/Message/MessageList';
import MessageCreate from './components/Config/Message/MessageCreate';
import MessageEdit from './components/Config/Message/MessageEdit';

// Call Inactivity Components
import CallInactivityConfig from './components/Config/CallInactivity/CallInactivityConfig';
import CallInactivityHistory from './components/Config/CallInactivity/CallInactivityHistory';

// Security Components
import Fail2banDashboard from './components/Security/Fail2ban/Fail2banDashboard';

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Provider>
          <div className="is-justify-content-end">
            <Header />
            <Burger />
            <Route exact path="/" component={ Login } />
            <Route exact path="/home" component={ Home } />
            <Route exact path="/dashboard" component={ Dashboard } />
            <Route exact path="/callcenter" component={ CallCenter } />
            <Route exact path="/callcenterV2" render={() => <CallcenterV2Layout><CallcenterV2 /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/dashboard" render={() => <CallcenterV2Layout><CallcenterV2DashboardRouter /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/history" render={() => <CallcenterV2Layout><CallcenterV2History /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/queues" render={() => <CallcenterV2Layout><CallcenterV2Queues /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/skills" render={() => <CallcenterV2Layout><CallcenterV2Skills /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/agents" render={() => <CallcenterV2Layout><CallcenterV2Agents /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/reports" render={() => <CallcenterV2Layout><CallcenterV2Reports /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/metrics/catalog" render={() => <CallcenterV2Layout><CallcenterV2MetricsCatalogAdmin /></CallcenterV2Layout>} />
            {/* Phase 5 routes — dashboards role-aware, admin screens, wallboard */}
            <Route exact path="/callcenterV2/dashboard/manager" render={() => <CallcenterV2Layout><CallcenterV2DashboardManager /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/dashboard/agent" render={() => <CallcenterV2Layout><CallcenterV2DashboardAgent /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/pause-reasons" render={() => <CallcenterV2Layout><CallcenterV2PauseReasons /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/work-schedules" render={() => <CallcenterV2Layout><CallcenterV2WorkSchedules /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/metrics/catalog-admin" render={() => <CallcenterV2Layout><CallcenterV2MetricsCatalogAdmin /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/feature-flags" render={() => <CallcenterV2Layout><CallcenterV2FeatureFlags /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/realtime" render={() => <CallcenterV2Layout><CallcenterV2Realtime /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/audit" render={() => <CallcenterV2Layout><CallcenterV2AuditLog /></CallcenterV2Layout>} />
            <Route exact path="/config" component={ Config } />
            <Route exact path="/config/ramal/novo" component={ CreateEndpoints } />
            <Route exact path="/config/ramal/lista" component={ ListEndpoints } />
            <Route exact path="/config/ramal/id" component={ ListEndpointsById } />
            <Route exact path="/config/tronco/novo" component={ CreateTrunks } />
            <Route exact path="/config/tronco/adicionar" component={ CreateTrunks } />
            <Route exact path="/config/tronco/editar" component={ EditTrunks } />
            <Route exact path="/config/tronco/lista" component={ ListTrunks } />
            <Route exact path="/config/tronco/id" component={ ListTrunksById } />
            <Route exact path="/config/tronco/inbound-dispatcher" component={ TrunksInboundDispatcherManage } />
            <Route exact path="/config/rede/ip" component={ ChangeIp } />
            <Route exact path="/config/rede/ip/lista" component={ InterfacesList } />
            <Route exact path="/config/rede/ip/routes" component={ RoutesNewSet } />
            <Route exact path="/config/rede/ip/routes/lista" component={ RoutesList } />
            <Route exact path="/config/rede/transportes-voz" component={ PjsipTransports } />
            <Route exact path="/config/rede/pjsip-tuning" component={ PjsipTuning } />
            <Route exact path="/config/fila/nova" component={ QueuesCreate } />
            <Route exact path="/config/fila/lista" component={ QueuesList } />
            <Route exact path="/config/fila/lista/nome" component={ QueuesListById } />
            <Route exact path="/config/fila/membros/novo" component={ MembersQueuesCreate } />
            <Route exact path="/config/fila/membros/lista" component={ QueuesMembersList } />
            <Route exact path="/config/fila/membros/lista/id" component={ MemberQueuesById } />
            <Route exact path="/config/direcionamentos/entrada" component={ DialPlanEntrance } />
            <Route exact path="/config/direcionamentos/interno" component={ DialPlanInternal } />
            <Route exact path="/config/direcionamentos/externo" component={ DialPlanExternal } />
            <Route exact path="/config/usuarios/novo" component={ CreateUsers } />
            <Route exact path="/config/usuarios/lista" component={ ListUsers } />
            <Route exact path="/config/usuarios/editar" component={ UsersEdit } />
            <Route exact path="/config/usuarios/visualizar" component={ UsersView } />
            <Route exact path="/config/uploads" component={ Uploads } />
            <Route exact path="/config/clientes/novo" component={ Tenants } />
            <Route exact path="/config/clientes/lista" component={ TenantsList } />
            <Route exact path="/config/uploads/lista" component={ UploadsList } />
            <Route exact path="/agenda/lista" component={ ListContacts } />
            <Route exact path="/agenda/novo" component={ NewContact } />
            <Route exact path="/agenda/contato/id" component={ ContactById } />
            <Route exact path="/agenda/contato/visualizar" component={ ContactShowById } />
            <Route exact path="/troubleshooting/sip" component={ LogsVigoscloud } />
            <Route exact path="/troubleshooting/comandos" component={ PingPage } />
            <Route exact path="/config/musica-de-espera/novo" component={ MohCreate } />
            <Route exact path="/config/musica-de-espera/editar" component={ MohEdit } />
            <Route exact path="/config/musica-de-espera/lista" component={ MohList } />
            <Route exact path="/config/musica-de-espera/visualizar" component={ MohView } />
            <Route exact path="/config/integracoes/lista" component={ IntegrationsList } />
            <Route exact path="/config/integracoes/nova" component={ IntegrationsCreate } />
            <Route exact path="/config/integracoes/editar" component={ IntegrationsEdit } />
            <Route exact path="/config/integracoes/visualizar" component={ IntegrationsView } />
            <Route exact path="/config/chamadas/internas" component={ InternalCallsList } />
            <Route exact path="/config/chamadas/internas/nova" component={ InternalCallsCreate } />
            <Route exact path="/config/chamadas/internas/editar" component={ InternalCallsEdit } />
            <Route exact path="/config/chamadas/internas/visualizar" component={ InternalCallsView } />
            <Route exact path="/config/chamadas/internas/estatisticas" component={ InternalCallsStatistics } />
            
            <Route exact path="/config/chamadas/saida" component={ OutboundCallsList } />
            <Route exact path="/config/chamadas/saida/nova" component={ OutboundCallsCreate } />
            <Route exact path="/config/chamadas/saida/editar" component={ OutboundCallsEdit } />
            <Route exact path="/config/chamadas/saida/visualizar" component={ OutboundCallsView } />
            
            {/* Incoming Calls Routes */}
            <Route exact path="/config/chamadas-entrada" component={ IncomingCallsList } />
            <Route exact path="/config/chamadas-entrada/criar" component={ IncomingCallsCreate } />
            <Route exact path="/config/chamadas-entrada/:id/editar" component={ IncomingCallsEdit } />
            <Route exact path="/config/chamadas-entrada/:id/visualizar" component={ IncomingCallsView } />
            <Route exact path="/config/chamadas-entrada/estatisticas" component={ IncomingCallsStatistics } />

            {/* URA Routes */}
            <Route exact path="/config/ura" component={ URAList } />
            <Route exact path="/config/ura/create" component={ URACreate } />
            <Route exact path="/config/ura/edit/:id" component={ URAEdit } />

            {/* Message Routes */}
            <Route exact path="/config/message" component={ MessageList } />
            <Route exact path="/config/message/create" component={ MessageCreate } />
            <Route exact path="/config/message/edit/:id" component={ MessageEdit } />

            {/* Call Inactivity Routes */}
            <Route exact path="/config/monitoramento-inatividade/configuracao" component={ CallInactivityConfig } />
            <Route exact path="/config/monitoramento-inatividade/historico" component={ CallInactivityHistory } />

            {/* Security Routes */}
            <Route exact path="/seguranca/fail2ban" component={ Fail2banDashboard } />
          </div>
        </Provider>
      </BrowserRouter>
    );
  }
}

export default App;
